import { apiClient } from "./apiClient";

// Edge'in son sensör değerlerini getir
export async function getLatestMetrics(accessToken, edgeId) {
  const res = await apiClient.get(`/metrics/latest/${edgeId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge'in sensör geçmişini getir (grafik için)
export async function getMetricsHistory(accessToken, edgeId, timeRange = "15m", field = null) {
  const params = { time_range: timeRange };
  if (field) {
    params.field = field;
  }
  const res = await apiClient.get(`/metrics/history/${edgeId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return res.data;
}

// Edge'in alarm geçmişini getir
export async function getEdgeAlarms(accessToken, edgeId, timeRange = "24h", limit = 50) {
  const res = await apiClient.get(`/metrics/alarms/${edgeId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params: { time_range: timeRange, limit },
  });
  return res.data;
}

// Edge'in anomali geçmişini getir
export async function getEdgeAnomalies(accessToken, edgeId, timeRange = "24h", limit = 50) {
  const res = await apiClient.get(`/metrics/anomalies/${edgeId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params: { time_range: timeRange, limit },
  });
  return res.data;
}
